import { createPromiseAction } from 'redux-saga-promise-actions';
import { SettingsPayload, SettingsResponse } from 'store/types/settings';

export const putSettings = createPromiseAction('PUT_SETTINGS', 'PUT_SETTINGS_SUCCEEDED', 'PUT_SETTINGS_FAILURE')<
  SettingsPayload,
  undefined,
  undefined
>();

export const getSettings = createPromiseAction('GET_SETTINGS', 'GET_SETTINGS_SUCCEEDED', 'GET_SETTINGS_FAILURE')<
  undefined,
  SettingsResponse,
  undefined
>();
